import { render, staticRenderFns } from "./TariffGroup.vue?vue&type=template&id=10e5c145"
import script from "./TariffGroup.vue?vue&type=script&lang=js"
export * from "./TariffGroup.vue?vue&type=script&lang=js"
import style0 from "./TariffGroup.vue?vue&type=style&index=0&id=10e5c145&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports